/**
 *  @shelf-version: 1.1.0
 */
import Video from './video'

export default Video
